(function()
{
    document.querySelectorAll('[data-carousel]').forEach(root=>{
        const track = root.querySelector('.carousel__track');
        const slides = [...root.querySelectorAll('.carousel__slide')];
        const prev = root.querySelector('[data-prev]');
        const next = root.querySelector('[data-next]');
        const dots = [...root.querySelectorAll('.carousel__dot')];
        let idx = 0;

        function paint(){
            track.style.transform = `translateX(-${idx*100}%)`;
            dots.forEach((d,i)=> d.setAttribute('aria-current', String(i===idx)));
        }
        prev?.addEventListener('click', ()=>{ idx = (idx-1+slides.length)%slides.length; paint(); });
        next?.addEventListener('click', ()=>{ idx = (idx+1)%slides.length; paint(); });
        dots.forEach((d,i)=>d.addEventListener('click', ()=>{ idx=i; paint(); }));
        paint();
    });
})();
